export default __webpack_public_path__ + "static/media/2_0010.83ea2d52.webp";